import { esusApi } from "@/services/api";
import { DentalAttendanceProcedure } from "@/@types/esus/DentalAttendanceProcedure";

export type DetailedCitizenProceduresIndicatorB3Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenProceduresIndicatorB3 {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	dentalAttendanceProcedures?: DentalAttendanceProcedure[];
}

export async function getDetailedCitizenProcedureIndicatorB3({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenProceduresIndicatorB3Params) {
	const response = await esusApi.get<DetailedCitizenProceduresIndicatorB3>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b3/detailed-citizen-procedures`,
		params
	);
	return response.data ?? new DetailedCitizenProceduresIndicatorB3();
}
